module.exports = __webpack_public_path__ + "static/media/confirmIcon.d249c61c.svg";